import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const items = [
  { key: "members_count", label: "Active Members", suffix: "" },
  { key: "channels_count", label: "Channels Live", suffix: "" },
  { key: "commands_executed", label: "Commands Run", suffix: "" },
  { key: "uptime_days", label: "Days Uptime", suffix: "d" },
  { key: "games_supported", label: "Games Tracked", suffix: "" },
];

export default function StatsSection() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api
      .get("/stats")
      .then((r) => setStats(r.data))
      .catch(() => setStats({}));
  }, []);

  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative border-y border-brand-line bg-brand-surface tactical-grid-fine"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="overline mb-3">// 03 · LIVE TELEMETRY</div>
        <h2 className="font-heading text-4xl md:text-5xl font-bold uppercase tracking-tight max-w-3xl">
          Real numbers. <span className="text-brand-orange">Real squad.</span>
        </h2>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-5 gap-px bg-brand-line">
          {items.map((it) => (
            <div
              key={it.key}
              className="bg-black p-6 md:p-8"
              data-testid={`stat-${it.key}`}
            >
              <div className="font-mono-tabular text-3xl md:text-5xl font-bold text-white">
                {stats?.[it.key]?.toLocaleString() ?? "—"}
                <span className="text-brand-orange">{it.suffix}</span>
              </div>
              <div className="overline mt-2">{it.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
